export const META_TYPE = 'entityCard';
export const META_VER = 'v1';

export const CMD_ENTITYCARD_REGISTRY_KEY = `${META_TYPE}:${META_VER}`;
